import React from 'react';

import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import GhaPoAwbPaymentsStatus from '../../../../models/GhaPoAwbPaymentsStatus';

import { paymentMethodMap } from '../../../../utils/paymentMethodMap';
import { formatCurrency } from '../../../../utils/currencyFormatter';

import style from './payments.module.css';

import moment, { Moment } from 'moment';

const styles = (theme: Theme) =>

  createStyles({
    checkCircleOutline: {
      fontSize: 14,
      position: 'absolute',
      top: 20,
      right: 90,
    },
    red: {
      color: 'red',
      cursor: 'pointer'
    },
    yellow: {
      color: 'orange', 
      cursor: 'pointer'
    },
    green: {
      color: 'green',
      cursor: 'pointer'
    },
    disabled: {
      color: 'gray',
      cursor: 'default'
    }
  });

interface PaymentsStatusProps {
    classes: any;
    status: Array<GhaPoAwbPaymentsStatus>;
    openModal: (id: number) => void;
};
  
const paymentsStatus = (props: PaymentsStatusProps) => {

  const { classes } = props;
  const paymentsStatus: any = props.status.map((status: GhaPoAwbPaymentsStatus, index: number) => {

    let iconColor: string = '';
    let statusName: string = '';
    const walletPayment = status.type == 'e wallet payment' && props.status.length > 1;

    switch (status.status) {
      case 'canceled' : 
        iconColor=`${ classes.red }`; 
        statusName = 'Not confirmed';
        break;
      case 'pending': 
        iconColor=`${ classes.yellow }`;
        statusName = 'Pending confirmation';
        break;
      case 'confirmed': 
        iconColor=`${ classes.green }`;
        statusName = 'Confirmed';
        break;
      default: return null;
    }
      return (
          <div key={ index } className={ [style.statusWrapper, walletPayment ? classes.disbaled : ''].join("") }>
              <div className={ style.statusIconWrapper }>
                  <span>Payment status: { statusName }, { moment(status.status_timestamp).format('DD MMM YY, hh:mm a').toUpperCase() };</span>
                  <CheckCircleOutline className={ iconColor } onClick={ walletPayment ? () => {} : ()=> props.openModal(status.id) }/>
              </div>
              <div>{ formatCurrency(status.amount, 2, '$') }/ { paymentMethodMap[status.type] }</div>
              <div>User ID: { status.user_created_first_name }  { status.user_created_last_name }</div>
          </div>
      )
    })
    return (
        <div>
            { paymentsStatus }
        </div>
    )
  }

  export default withStyles(styles)(paymentsStatus);